// src/api/Proyectos/ProyectosTareasApi.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
};

// ✅ Obtener todas las tareas de un proyecto
export const getTareasByProyecto = async (proyectoId) => {
  const response = await axios.get(
    `${API_URL}/api/proyectos/${proyectoId}/tareas`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// ✅ Crear una nueva tarea
export const createTarea = async (proyectoId, tarea) => {
  const response = await axios.post(
    `${API_URL}/api/proyectos/${proyectoId}/tareas`,
    tarea,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// ✅ Actualizar una tarea
export const updateTarea = async (id, tarea) => {
  const response = await axios.put(`${API_URL}/api/tareas/${id}`, tarea, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// ✅ Eliminar una tarea
export const deleteTarea = async (id) => {
  const response = await axios.delete(`${API_URL}/api/tareas/${id}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// ------------------------------
// 👇 Relaciones dinámicas
// ------------------------------

// ✅ Diseños (productos en tu sistema)
export const getDisenos = async () => {
  const response = await axios.get(`${API_URL}/api/productos`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// ✅ Muestras
export const getMuestras = async () => {
  const response = await axios.get(`${API_URL}/api/muestras`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// ✅ Materiales
export const getMateriales = async () => {
  const response = await axios.get(`${API_URL}/api/materialoteca`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// ✅ Responsables (users con rol de diseñadores o todos)
export const getResponsables = async () => {
  const response = await axios.get(`${API_URL}/api/users/designers`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// ✅ Responsables (users con rol de diseñadores o todos)
export const getResponsablesTodos = async () => {
  const response = await axios.get(`${API_URL}/api/users/todos`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// Obtener definiciones de tareas

export const getTareasDefinicion = async () => {
  const token = localStorage.getItem("token");
  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/api/tareas-definicion`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.json();
};

// status: 'ongoing' | 'finished' | 'all'
// Acepta también boolean legacy (false → ongoing, true → all) y valores de ToDoList.
export const getAllTareas = async (includeDone = "ongoing") => {
  let status = "ongoing";
  if (includeDone === true || includeDone === "all") status = "all";
  else if (includeDone === "finished") status = "finished";
  else if (includeDone === false || includeDone === "ongoing") status = "ongoing";

  const response = await axios.get(`${API_URL}/api/tareas?status=${status}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

/** Pendientes: responsable, Owner del cliente, o participante. Admin: todas. */
export const getMisTareasPendientes = async () => {
  const response = await axios.get(`${API_URL}/api/tareas/mis-pendientes`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// 💬 Chat de tareas
export const getTareasMensajes = async (tareaId) => {
  const res = await axios.get(`${API_URL}/api/tareas/${tareaId}/mensajes`, {
    headers: getAuthHeaders(),
  });
  return res.data;
};

export const postTareasMensaje = async (tareaId, data) => {
  const res = await axios.post(
    `${API_URL}/api/tareas/${tareaId}/mensajes`,
    data,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const getTareasParticipantes = async (tareaId) => {
  const res = await axios.get(
    `${API_URL}/api/tareas/${tareaId}/participantes`,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const postTareasParticipante = async (tareaId, data) => {
  const res = await axios.post(
    `${API_URL}/api/tareas/${tareaId}/participantes`,
    data,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

// VER LOS MENSAJES DE LAS TAREAS LEIDAS
export const marcarMensajesLeidos = async (tareaId) => {
  const res = await axios.post(
    `${API_URL}/api/tareas/${tareaId}/mensajes/leidos`,
    {},
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const getMensajesNoLeidos = async (tareaId, userId) => {
  const res = await axios.get(
    `${API_URL}/api/tareas/${tareaId}/mensajes/noleidos/${userId}`,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const getTareasMensajesCount = async (tareaId) => {
  const res = await axios.get(
    `${API_URL}/api/tareas/${tareaId}/mensajes/count`,
    { headers: getAuthHeaders() }
  );
  return res.data.total;
};

// ❌ Eliminar participante de una tarea
export const deleteTareasParticipante = async (tareaId, userId) => {
  const res = await axios.delete(
    `${API_URL}/api/tareas/${tareaId}/participantes/${userId}`,
    { headers: getAuthHeaders() }
  );
  return res.data;
};
